import TutorialMsgText from "./G.TutorialMsgText";

const TUTORIAL_POSITION = {
  top: 0.15,
  middle: 0.5,
  mid: 0.5,
  bottom: 0.93,
  bot: 0.93,
};

G.GingyTutorialBar = function () {
  Phaser.Group.call(this, game);

  this.x = 320;
  // this.bar = G.makeImage(0, 0, "tutorial_bar", 0.5, this);
  this.bar = game.add.tileSprite(0, 0, 2000, 222, 'ginger', 'tutorial_bar', this);
  this.bar.anchor.setTo(0.5);

  this.gingy = this.add(new G.GingyCharacterTutorial());
  this.msg = this.add(new TutorialMsgText(90, 0));

  this.iconContainer = game.make.group(this);
  this.icon = G.makeImage(0, 160, null, 0.5, this.iconContainer);

  this.renderedBounds = this.getBounds();

  // change to onScreenResize
  this.pY = 0.12;
  this.hide(null, null, true);
};

G.GingyTutorialBar.prototype = Object.create(Phaser.Group.prototype);

G.GingyTutorialBar.prototype.update = function () {
  this.updatePYPosition(false);
};

// split to 2 functions for hidden and not
G.GingyTutorialBar.prototype.displayMsg = function (data) {
  if (this.game === null) return;

  if (this.hidden) {
    if (data.position) {
      this.pY = TUTORIAL_POSITION[data.position];
      this.updatePYPosition(true);
    }
    this.show(function () {
      this.displayMsg(data);
    }, this);
  } else {
    if (data.position) {
      this.pY = TUTORIAL_POSITION[data.position];
    }
    this.msg.displayText(data.text);
    this.gingy.talk();
    this.msg.onTextAnimationFinished.addOnce(function () {
      this.gingy.idle();
    }, this);

    if (data.gingy) {
      if (data.gingy.lookAt) this.gingy.lookAt(data.gingy.lookAt);
    }

    this.processIconData(data.icon);
  }
};

G.GingyTutorialBar.prototype.updatePYPosition = function (optImmediate) {
  if (optImmediate) {
    this.y = Math.floor(game.height * this.pY);
  } else {
    this.y = G.lerp(
      this.y,
      Math.floor(this.pY * game.height),
      0.3, 1,
    );
  }
};

// split into show icon and hide
G.GingyTutorialBar.prototype.processIconData = function (iconData) {
  if (iconData && iconData.sprite) {
    this.icon.scale.setTo(0);
    this.icon.changeTexture(iconData.sprite);
    this.icon.y = iconData.y || 160;
    game.add.tween(this.icon.scale)
      .to({ x: 1, y: 1 }, 300, Phaser.Easing.Sinusoidal.Out, true);
  } else {
    game.add.tween(this.icon.scale)
      .to({ x: 0, y: 0 }, 300, Phaser.Easing.Sinusoidal.Out, true)
      .onComplete.add(function () {
        this.icon.changeTexture(null);
      }, this);
  }
};

G.GingyTutorialBar.prototype.hide = function (callback, context, immediate) {
  if (this.hidden) {
    if (callback) callback.call(context);
    return;
  }

  this.hidden = true;


  // move stuff to animation folder
  // for immediate - setProgressTo1()
  if (immediate) {
    this.msg.alpha = 0;
    this.gingy.scale.setTo(0);
    this.bar.scale.y = 0;
    this.iconContainer.scale.setTo(0);
    if (callback) callback.call(context);
  } else {
    game.add.tween(this.msg)
      .to({ alpha: 0 }, 150, Phaser.Easing.Sinusoidal.In, true);
    game.add.tween(this.gingy.scale)
      .to({ x: 0, y: 0 }, 150, Phaser.Easing.Sinusoidal.In, true);
    game.add.tween(this.bar.scale)
      .to({ y: 0 }, 200, Phaser.Easing.Sinusoidal.In, true, 150)
      .onComplete.add(function () {
        if (callback) callback.call(context);
      });
    game.add.tween(this.iconContainer.scale)
      .to({ x: 0, y: 0 }, 300, Phaser.Easing.Sinusoidal.In, true, 100);
  }
};

G.GingyTutorialBar.prototype.show = function (callback, context) {
  if (!this.hidden) {
    if (callback) callback.call(context);
    return;
  }

  this.hidden = false;

  this.bar.scale.y = 0;
  this.gingy.scale.setTo(0);

  game.add.tween(this.msg)
    .to({ alpha: 1 }, 150, Phaser.Easing.Sinusoidal.In, true);
  game.add.tween(this.bar.scale)
    .to({ y: 1 }, 400, Phaser.Easing.Elastic.Out, true);
  game.add.tween(this.gingy.scale)
    .to({ x: 1, y: 1 }, 800, Phaser.Easing.Elastic.Out, true, 100)
    .onComplete.add(function () {
      if (callback) callback.call(context);
    });
  game.add.tween(this.iconContainer.scale)
    .to({ x: 1, y: 1 }, 300, Phaser.Easing.Elastic.Out, true, 100);
};
